import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, HardHat, FileText, Receipt, ClipboardList, PhoneCall, AlertTriangle, Calendar, Wrench, Ticket, GraduationCap, Building2, Menu, X, LogOut, ChevronRight, Mail, CheckSquare } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { trainingSections } from '../data/trainingSections';
export function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const [isTrainingOpen, setIsTrainingOpen] = useState(location.pathname.startsWith('/training'));
  const navigation = [{
    name: 'Dashboard',
    href: '/',
    icon: LayoutDashboard
  }, {
    name: 'Commerciale',
    href: '/commercial',
    icon: PhoneCall
  }, {
    name: 'Scadenze',
    href: '/deadlines',
    icon: Calendar
  }, {
    name: 'Anagrafiche clienti',
    href: '/clients',
    icon: Users
  }, {
    name: 'Risorse umane',
    href: '/workers',
    icon: HardHat
  }, {
    name: 'Offerte e contratti',
    href: '/contracts',
    icon: FileText
  }, {
    name: 'Fatturazione',
    href: '/invoicing',
    icon: Receipt
  }, {
    name: 'Attività operative',
    href: '/operations',
    icon: ClipboardList
  }, {
    name: 'Azioni',
    href: '/actions',
    icon: CheckSquare
  }, {
    name: 'Non conformità',
    href: '/non-conformities',
    icon: AlertTriangle
  }, {
    name: 'Asset e manutenzioni',
    href: '/equipment',
    icon: Wrench
  }, {
    name: 'Formazione',
    href: '/training',
    icon: GraduationCap
  }, {
    name: 'Studi',
    href: '/studies',
    icon: Building2
  }, {
    name: 'Ticket',
    href: '/tickets',
    icon: Ticket
  }];
  const toggleSidebar = () => setIsOpen(!isOpen);
  return <>
      {/* Mobile menu button */}
      <div className="lg:hidden fixed top-0 left-0 z-40 p-4 w-full bg-seform-navy flex justify-between items-center shadow-md" data-id="element-969" data-mp="2qxsn5c00y3sa">
        <div className="flex items-center gap-3" data-id="element-970" data-mp="2h8r2h8ijay7z">
          <img src="https://cdn.magicpatterns.com/uploads/1KdRBrYowz6fjdh8tvZpwA/logo_sef_crm.svg" alt="SEF" className="h-10 w-auto brightness-0 invert" data-id="element-971" data-mp="2h77ojokcoz9d" />
        </div>
        <button onClick={toggleSidebar} className="p-2 rounded-md text-white hover:bg-white/10 focus:outline-none" data-id="element-972" data-mp="289dw4oppiprh">
          {isOpen ? <X className="h-6 w-6" data-id="element-973" data-mp="1y94u2u91aa46" /> : <Menu className="h-6 w-6" data-id="element-974" data-mp="1yaev9sb6nyf1" />}
        </button>
      </div>

      {/* Sidebar backdrop for mobile */}
      {isOpen && <div className="fixed inset-0 z-30 bg-slate-900/50 backdrop-blur-sm lg:hidden" onClick={() => setIsOpen(false)} data-id="element-975" data-mp="1uanwp2ff0dzy"></div>}

      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-40 w-72 text-white transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0 shadow-xl flex flex-col overflow-hidden
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `} style={{
      background: 'linear-gradient(180deg, #2D1B69 0%, #1E3A5F 100%)'
    }} data-id="element-976" data-mp="3on3x3mlj4xww">
        {/* Decorative pittogramma in bottom right */}
        <div className="absolute bottom-0 right-0 w-36 pointer-events-none opacity-10" data-id="element-977" data-mp="rgh1xxshbqyz">
          <img src="https://cdn.magicpatterns.com/uploads/puU4xF5g7Qr5V1qPGx34qa/icona_celeste.svg" alt="" className="w-full h-auto object-contain" aria-hidden="true" data-id="element-978" data-mp="wea6kme4wcx5" />
        </div>

        {/* Logo Area */}
        <div className="h-24 px-6 flex items-center border-b border-white/10 relative" data-id="element-979" data-mp="15ddtk1gf9cgx">
          <div className="flex items-center z-10" data-id="element-980" data-mp="2bvajxli36177">
            <img src="https://cdn.magicpatterns.com/uploads/1KdRBrYowz6fjdh8tvZpwA/logo_sef_crm.svg" alt="SEF" className="h-14 w-auto brightness-0 invert" data-id="element-981" data-mp="2gtuay0bje36f" />
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-4 py-6 space-y-1 overflow-y-auto custom-scrollbar relative z-10" data-id="element-982" data-mp="2agpyy9ce1gbq">
          {navigation.map(item => {
          if (item.href === '/training') {
            const isSectionActive = location.pathname.startsWith('/training');
            return <div key={item.name} data-id="element-983" data-mp="2y9zip6g897mb">
                  <button type="button" onClick={() => setIsTrainingOpen(v => !v)} aria-expanded={isTrainingOpen} aria-controls="sidebar-training-submenu" className={`group w-full flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-colors duration-200 ${isSectionActive ? 'text-white bg-white/10' : 'text-slate-300 hover:bg-white/10 hover:text-white'}`} data-id="element-984" data-mp="2te11c2tbgpve">
                    <item.icon className="mr-3 h-5 w-5 flex-shrink-0 transition-transform duration-200 group-hover:scale-110" data-id="element-985" data-mp="3vp0qebntdgar" />
                    <span className="flex-1 truncate text-left" data-id="element-986" data-mp="4hwkxl7bi24g">
                      {item.name}
                    </span>
                    <ChevronRight className={`h-4 w-4 opacity-70 transition-transform duration-200 ${isTrainingOpen ? 'rotate-90' : ''}`} aria-hidden="true" data-id="element-987" data-mp="3mqx61iokepkj" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-988" data-mp="3hq13b8fy99gp">
                    {isTrainingOpen && <motion.ul id="sidebar-training-submenu" initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.2,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden ml-6 pl-3 border-l border-white/15 space-y-0.5" data-id="element-989" data-mp="331msobcakgpl">
                        {trainingSections.map(sub => {
                    const href = `/training/${sub.slug}`;
                    const isSubActive = location.pathname === href || location.pathname.startsWith(`${href}/`);
                    return <li key={sub.slug} className="first:pt-1" data-id="element-990" data-mp="1ij2kaxdksnj9">
                              <NavLink to={href} onClick={() => setIsOpen(false)} className={`block px-3 py-2 text-sm rounded-lg truncate transition-colors duration-150 ${isSubActive ? 'bg-seform-orange text-white font-medium' : 'text-slate-300 hover:bg-white/10 hover:text-white'}`} data-id="element-991" data-mp="1igq68vaxuxbh">
                                {sub.sidebarLabel}
                              </NavLink>
                            </li>;
                  })}
                      </motion.ul>}
                  </AnimatePresence>
                </div>;
          }
          const isActive = location.pathname === item.href;
          return <NavLink key={item.name} to={item.href} onClick={() => setIsOpen(false)} className={`
                  group flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-200 relative overflow-hidden
                  ${isActive ? 'bg-seform-orange text-white shadow-lg shadow-orange-500/20' : 'text-slate-300 hover:bg-white/10 hover:text-white'}
                `} data-id="element-992" data-mp="2njkc9xoy46u5">
                <item.icon className={`mr-3 h-5 w-5 flex-shrink-0 transition-transform duration-200 ${isActive ? 'scale-110' : 'group-hover:scale-110'}`} data-id="element-993" data-mp="1831yo56v7ewr" />
                <span className="flex-1 truncate" data-id="element-994" data-mp="t4hc8to17rse">{item.name}</span>
                {isActive && <ChevronRight className="h-4 w-4 opacity-50" data-id="element-995" data-mp="o6fuqd6980j1" />}
              </NavLink>;
        })}
        </nav>

        {/* User Profile */}
        <div className="p-4 border-t border-white/10 bg-black/20 relative z-10" data-id="element-996" data-mp="xx0s5xa6yz0d">
          <div className="flex items-center gap-3 p-2 rounded-xl hover:bg-white/5 transition-colors cursor-pointer group" data-id="element-997" data-mp="xzeijstxfn1l">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center text-white font-bold shadow-md" data-id="element-998" data-mp="58mpv5c2lgj0">
              AL
            </div>
            <div className="flex-1 min-w-0" data-id="element-999" data-mp="e9b2pwpq9aub">
              <p className="text-sm font-semibold text-white truncate" data-id="element-1000" data-mp="e7hw2hf46qmb">
                Alessio
              </p>
              <p className="text-xs text-slate-400 truncate" data-id="element-1001" data-mp="1ulghbs9e36cy">Responsabile</p>
            </div>
            <LogOut className="h-5 w-5 text-slate-400 group-hover:text-white transition-colors" data-id="element-1002" data-mp="1pnyfeltshreg" />
          </div>
        </div>
      </div>
    </>;
}